export default {
  form: {
    display_name: {
      label: 'Nombre del restaurante',
      placeholder: 'Introduce el nombre del restaurante',
      help: 'Se usa en tu contrato y facturas',
    },
    store_address: {
      label: 'Dirección del establecimiento',
      placeholder: 'Busca tu dirección',
      help: 'Esta es la dirección que ven tus clientes',
    },
    address: {
      label: 'Dirección',
      placeholder: 'Calle y número',
    },
    zip_code: {
      label: 'Código postal',
      placeholder: 'Código postal',
    },
    city: {
      label: 'Ciudad',
      placeholder: 'Ciudad',
    },
    state: {
      label: 'Provincia',
      placeholder: 'Selecciona provincia',
    },
    country: {
      label: 'País',
      help: 'Para trasladar tu restaurante a otro país, contacta con soporte',
    },
  },
  staff_notice:
    'El personal de la tienda no puede confirmar el nombre y la dirección del restaurante. Pide a tu gestor de incorporación que revise estos datos.',
  toasts: {
    saved: 'Datos del establecimiento guardados',
    error: 'No se pudieron guardar los datos de tu establecimiento',
  },
  buttons: {
    next: 'Siguiente',
  },
};
